<template>
  <div>
    <a-card title="产品信息">
      <!-- 赋码统计信息 -->
      <div style="margin-bottom: 12px;">
        <a-button type="link" size="small" style="padding: 0; color: rgba(0,0,0,0.45); font-size: 13px;" @click="statsExpanded = !statsExpanded">
          <a-icon :type="statsExpanded ? 'up' : 'down'" style="margin-right: 4px;" />
          赋码统计：共 {{ codingStats.total || 0 }} 个商品，已赋码 {{ codingStats.coded || 0 }} 个，未赋码 {{ codingStats.uncoded || 0 }} 个，赋码率 {{ codingStats.codedRate || 0 }}%
        </a-button>
        <div v-if="statsExpanded" style="background: #fafafa; padding: 16px; border-radius: 4px; margin-top: 8px;">
          <a-row :gutter="16">
            <a-col :span="6">
              <a-statistic title="商品总数" :value="codingStats.total || 0">
                <template #suffix>
                  <span style="font-size: 14px;">个</span>
                </template>
              </a-statistic>
            </a-col>
            <a-col :span="6">
              <a-statistic title="已赋码商品" :value="codingStats.coded || 0" :value-style="{ color: '#52c41a' }">
                <template #suffix>
                  <span style="font-size: 14px;">个</span>
                </template>
              </a-statistic>
            </a-col>
            <a-col :span="6">
              <a-statistic title="未赋码商品" :value="codingStats.uncoded || 0" :value-style="{ color: '#faad14' }">
                <template #suffix>
                  <span style="font-size: 14px;">个</span>
                </template>
              </a-statistic>
            </a-col>
            <a-col :span="6">
              <div>
                <div style="font-size: 14px; color: rgba(0, 0, 0, 0.45); margin-bottom: 8px;">赋码率</div>
                <a-progress
                  :percent="codingStats.codedRate || 0"
                  :status="codingStats.codedRate === 100 ? 'success' : 'active'"
                  :stroke-width="12"
                />
              </div>
            </a-col>
          </a-row>
        </div>
      </div>

      <a-row :gutter="16">
        <a-col :span="24" style="max-width: 200px; margin-bottom: 12px;">
          <a-input v-model="searchForm.search" placeholder="编号, 名称, 备注" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px;">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>

        <a-col :span="24" style="width: 380px; margin-bottom: 12px;">
          <a-button-group>
            <a-button icon="file-excel" @click="downloadTemplate">模板下载</a-button>
            <a-upload name="file" :showUploadList="false" :customRequest="importExcel">
              <a-button icon="upload">导入</a-button>
            </a-upload>
            <a-button icon="download" @click="exportExcel">导出</a-button>
            <a-button icon="barcode" @click="openBatchCodingDrawer">批量赋码</a-button>
          </a-button-group>
        </a-col>

        <div style="margin-bottom: 12px; float: right;">
          <a-button type="primary" icon="plus" style="margin: 0 8px;" @click="openFormModal(form)">新增产品</a-button>
        </div>
      </a-row>

      <a-row style="margin-top: 12px;">
        <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading"
          :pagination="pagination" @change="tableChange"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: getCheckboxProps}"
>
          <div slot="images" slot-scope="value">
            <template v-if="value && value[0]">
              <template v-if="isImageFile(getFileUrl(value[0]))">
                <img style="width: 60px; height: 60px; object-fit: cover; cursor: pointer; border-radius: 4px;"
                  :src="getFileUrl(value[0])"
                  @click="onClick(getFileUrl(value[0]))"
/>
              </template>
              <template v-else>
                <a :href="getFileUrl(value[0])" target="_blank" style="text-decoration: none;">
                  <div style="width:60px; height:60px; border:1px solid #e8e8e8; border-radius:4px; display:flex; flex-direction:column; align-items:center; justify-content:center; background:#f5f5f5; cursor:pointer;">
                    <a-icon :type="getFileIcon(getFileUrl(value[0]))" style="font-size:22px; color:#1890ff;" />
                    <span style="font-size:10px; color:#666; margin-top:4px; text-transform:uppercase;">{{ getFileExt(getFileUrl(value[0])) }}</span>
                  </div>
                </a>
              </template>
            </template>
          </div>
          <div slot="types" slot-scope="value">
            <a-tag :color="value === 'material' ? 'orange' : value === 'semi_product' ? 'blue' : 'green'">
              {{ value === 'material' ? '原料' : value === 'semi_product' ? '半成品' : '产品' }}
            </a-tag>
          </div>
          <div slot="trace_status" slot-scope="value, item">
            <template v-if="item.types === 'product'">
              <a-tag v-if="value === 'complete'" color="green">已完整</a-tag>
              <a-tag v-else-if="value === 'pending'" color="orange">已赋码/待完善</a-tag>
              <a-tag v-else color="red">未赋码</a-tag>
              <a-tooltip v-if="value === 'unarchived'" title="赋码" :mouseLeaveDelay="0">
                <a-icon type="barcode" style="cursor: pointer; color: #1890ff; font-size: 16px; margin-left: 8px;" @click="singleCoding(item)" />
              </a-tooltip>
              <a-tooltip v-else-if="value === 'pending' || value === 'complete'" title="查看追溯信息" :mouseLeaveDelay="0">
                <a-icon type="file-search" style="cursor: pointer; color: #1890ff; font-size: 16px; margin-left: 8px;" @click="goToTrace(item)" />
              </a-tooltip>
            </template>
          </div>
          <div slot="is_active" slot-scope="value">
            <a-tag :color="value ? 'green' : 'red'">{{ value ? '激活' : '冻结' }}</a-tag>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button icon="edit" size="small" @click="openFormModal(item)">编辑</a-button>
              <a-popconfirm title="确定删除吗" @confirm="destroy(item.id)">
                <a-button type="danger" icon="delete" size="small">删除</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
    <form-modal :visible="visible" :form="targetItem" @getClassInfo="getClassInfo" @getUnitInfo="getUnitInfo"
      :classificationItems="classificationItems" :unitItems="unitItems"
      :warehouseItems="warehouseItems" @create="create" @update="update" @cancel="visible = false"
/>
    <a-modal v-model="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
    <a-modal v-model="importLoading" :footer="null" :maskClosable="false" :closable="false">
      <div>
        <a-spin style="margin-right: 12px;" />正在导入中, 请等待...
      </div>
    </a-modal>

    <!-- 批量赋码抽屉 -->
    <a-drawer
      title="批量赋码"
      :width="500"
      :visible="batchCodingVisible"
      :body-style="{ paddingBottom: '80px' }"
      @close="batchCodingVisible = false"
    >
      <a-spin :spinning="codingLoading">
        <div style="margin-bottom: 24px;">
          <a-alert
            v-if="codingError"
            :message="codingError"
            type="error"
            closable
            @close="codingError = ''"
            style="margin-bottom: 16px;"
          />

          <a-descriptions title="统计信息" bordered :column="1">
            <a-descriptions-item label="商品总数">
              {{ codingStats.total || 0 }}
            </a-descriptions-item>
            <a-descriptions-item label="已赋码商品">
              <a-tag color="green">{{ codingStats.coded || 0 }}</a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="未赋码商品">
              <a-tag color="orange">{{ codingStats.uncoded || 0 }}</a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="赋码率">
              <a-progress
                :percent="codingStats.codedRate || 0"
                :status="codingStats.codedRate === 100 ? 'success' : 'active'"
              />
            </a-descriptions-item>
          </a-descriptions>

          <a-alert
            v-if="selectedRowKeys.length > 0"
            :message="`已选择 ${selectedRowKeys.length} 个商品`"
            type="info"
            show-icon
            style="margin-top: 16px;"
          />
        </div>

        <div style="margin-top: 24px;">
          <a-space>
            <a-button
              type="primary"
              icon="barcode"
              :disabled="codingStats.uncoded === 0"
              @click="batchCoding"
            >
              {{ selectedRowKeys.length > 0 ? '为选中商品赋码' : '为全部未赋码商品赋码' }}
            </a-button>
            <a-button @click="batchCodingVisible = false">取消</a-button>
          </a-space>
        </div>
      </a-spin>
    </a-drawer>
  </div>
</template>

<script>
import { exportExcel } from '@/utils/excel'
import { goodsInformationExport } from '@/api/export'
import { goodsInformationTemplate, goodsInformationImport } from '@/api/import'
import { goodsInformationList, goodsInformationDetail, goodsInformationDestroy, goodsCodingStats, goodsBatchCoding } from '@/api/goods'
import { goodsClassificationOption, goodsUnitOption, warehousesOption } from '@/api/option'
import { getGoodsNumber } from '@/api/data'

export default {
  name: 'Warehouse',
  components: {
    FormModal: () => import('./FormModal.vue'),
  },
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          customRender: (value, item, index) => {
            return index + 1
          },
        },
        {
          title: '产品id',
          dataIndex: 'id',
          sorter: true,
        },
        {
          title: '示例图',
          dataIndex: 'images',
          scopedSlots: { customRender: 'images' }
        },
        {
          title: '产品编号',
          dataIndex: 'number',
          sorter: true,
        },
        {
          title: '产品名称',
          dataIndex: 'name',
          sorter: true,
        },
        {
          title: '分类',
          dataIndex: 'category_name',
        },
        {
          title: '类型',
          dataIndex: 'types',
          scopedSlots: { customRender: 'types' },
        },
        {
          title: '追溯/赋码状态',
          dataIndex: 'trace_status',
          scopedSlots: { customRender: 'trace_status' },
        },
        {
          title: '采购价',
          dataIndex: 'purchase_price',
        },
        {
          title: '零售价',
          dataIndex: 'retail_price',
        },
        {
          title: '单位',
          dataIndex: 'unit_name',
        },
        {
          title: '状态',
          dataIndex: 'is_active',
          scopedSlots: { customRender: 'is_active' }
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '156px'
        },
      ],
      searchForm: { search: '', page: 1, page_size: 16 },
      pagination: { current: 1, total: 0, pageSize: 16 },
      loading: false,
      items: [],
      items_product: [],
      classificationItems: [],
      unitItems: [],
      warehouseItems: [],
      visible: false,
      targetItem: {
        types: undefined,
        period_unit: '天',
        category: undefined,
        unit: undefined,
        is_active: true,
        images: [],
        association: [],
      },
      form: {
        types: undefined,
        period_unit: '天',
        category: undefined,
        unit: undefined,
        is_active: true,
        images: [],
        association: [],
      },
      importLoading: false,
      // 赋码统计折叠
      statsExpanded: false,
      // 批量赋码相关
      batchCodingVisible: false,
      selectedRowKeys: [],
      codingStats: {
        total: 0,
        coded: 0,
        uncoded: 0,
        codedRate: 0
      },
      codingLoading: false,
      codingError: '',
    };
  },
  mounted() {
    this.initialize();
    this.loadCodingStats(); // 加载赋码统计
  },
  methods: {
    getFileUrl(file) {
      if (!file) return ''
      if (typeof file === 'string') return file
      return (file.response && file.response.data && file.response.data.file_url) || file.url || ''
    },
    isImageFile(url) {
      if (!url) return false
      return /\.(jpg|jpeg|png|gif|bmp|webp)(\?.*)?$/i.test(url)
    },
    getFileExt(file) {
      const url = this.getFileUrl(file)
      if (!url) return 'FILE'
      const ext = url.split('/').pop().split('?')[0].split('.').pop()
      return ext ? ext.toUpperCase() : 'FILE'
    },
    getFileIcon(file) {
      const ext = this.getFileExt(file).toLowerCase()
      if (['xls', 'xlsx'].includes(ext)) return 'file-excel'
      if (['doc', 'docx'].includes(ext)) return 'file-word'
      if (ext === 'pdf') return 'file-pdf'
      if (['zip', 'rar', '7z'].includes(ext)) return 'file-zip'
      if (['txt', 'csv'].includes(ext)) return 'file-text'
      return 'file'
    },
    getFileName(url) {
      if (!url) return ''
      return url.split('/').pop().split('?')[0]
    },
    onClick(val) {
      this.previewVisible = true
      this.previewImage = val
    },
    initialize() {
      this.list();
    },
    getClassInfo() {
      goodsClassificationOption({ page_size: 999999, is_active: true }).then((resp) => {
        this.classificationItems = resp.results;
      });
    },
    getUnitInfo() {
      goodsUnitOption({ page_size: 999999, is_active: true }).then((resp) => {
        this.unitItems = resp.results;
      });
    },
    list() {
      this.loading = true;
      goodsInformationList(this.searchForm).then(data => {
        this.pagination.total = data.count;
        this.items = data.results;

        this.items_product = data.results.filter(function (item) {
          return item.types === "product";
        });

      }).finally(() => {
        this.loading = false;
      });
    },
    create(item) {
      this.list();
      this.loadCodingStats(); // 刷新统计
      this.visible = false
    },
    update(item) {
      this.list();
      this.loadCodingStats(); // 刷新统计
      this.visible = false
    },
    search() {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    openFormModal(item) {
      // item.shelf_life_days = item.shelf_life_days && item.shelf_life_days.replace(/\D/g, "");
      if (!item.id) {
        getGoodsNumber().then(data => {
          this.targetItem = { ...JSON.parse(JSON.stringify(item)), number: data.number, images: [], types: 'product' };
        })
      } else {
        // 编辑模式：调用详情接口获取完整数据（包含 inventory_items）
        goodsInformationDetail(item.id).then(detailData => {
          this.targetItem = {
            ...detailData, ...{
              images: detailData.images && detailData.images.map((img, index) => {
                if (!img.response) {
                  const n = img.split('/')
                  return {
                    uid: index + '',
                    name: n[n.length - 1],
                    status: 'done',
                    url: img,
                  }
                } else {
                  return img
                }
              }) || [],
              association: detailData.association || [],
              period_unit: detailData.period_unit || '天',
              category: detailData.category != null ? detailData.category : undefined,
              unit: detailData.unit != null ? detailData.unit : undefined,
              is_active: detailData.is_active != null ? detailData.is_active : true,
            }
          };

          // 获取仓库列表并填充库存数据
          warehousesOption({ page_size: 999999, is_active: true }).then((resp) => {
            this.warehouseItems = resp.results && resp.results.map(warehouseItem => {
              const inventoryItems = detailData.inventory_items || [];
              let index = inventoryItems.findIndex(_item => _item.warehouse == warehouseItem.id);
              if (index != -1) {
                // 有库存记录的仓库：填充数据并标记
                const qty = inventoryItems[index].initial_quantity;
                // 如果 initial_quantity 为 0，显示为空（未设置）
                warehouseItem.initial_quantity = (qty === 0 || qty === null) ? undefined : qty;
                warehouseItem.batch_items = inventoryItems[index].batch_items || [];
                warehouseItem._hasInventoryRecord = true; // 标记：原本有库存记录
              } else {
                // 没有库存记录的仓库：标记为无记录
                warehouseItem._hasInventoryRecord = false;
              }
              return warehouseItem
            });
          });
        }).catch(err => {
          this.$message.error('获取商品详情失败：' + (err.message || '网络错误'));
        });
      }
      this.getClassInfo();
      this.getUnitInfo();

      // 新增模式：直接获取仓库列表，不初始化 initial_quantity（保持 undefined）
      if (!item.id) {
        warehousesOption({ page_size: 999999, is_active: true }).then((resp) => {
          this.warehouseItems = resp.results;
        });
      }

      this.visible = true;
    },
    destroy(id) {
      goodsInformationDestroy({ id }).then(() => {
        // this.items.splice(this.items.findIndex(item => item.id == id), 1);
        this.$message.success('删除成功');
        this.list();
        this.loadCodingStats(); // 刷新统计
      });
    },
    exportExcel() {
      goodsInformationExport(this.searchForm).then(resp => {
        exportExcel(resp.data, '产品信息列表');
      }).catch(err => {
        this.$message.error(err.response.data.error);
      });
    },
    downloadTemplate() {
      goodsInformationTemplate().then(resp => {
        exportExcel(resp.data, '产品信息导入模板');
      }).catch(err => {
        this.$message.error(err.response.data.error);
      });
    },
    importExcel(item) {
      let data = new FormData();
      data.append('file', item.file);
      this.importLoading = true;
      setTimeout(() => {
        goodsInformationImport(data)
          .then(() => {
            this.$message.success('导入成功');
            this.list();
          })
          .catch(err => {
            alert("导入错误:" + "\n" + err.response.data.join("\n"));
          })
          .finally(() => {
            this.importLoading = false;
          });
      }, 1000);
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.searchForm.page_size = pagination.pageSize;
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      if (sorter && sorter.field && sorter.order) {
        this.searchForm.ordering = `${sorter.order === 'descend' ? '-' : ''}${sorter.field}`;
      } else {
        delete this.searchForm.ordering;
      }
      this.list();
    },
    // 加载赋码统计
    loadCodingStats() {
      goodsCodingStats()
        .then((res) => {
          this.codingStats = {
            total: res.total || 0,
            coded: res.coded || 0,
            uncoded: res.uncoded || 0,
            codedRate: res.total > 0 ? Math.round((res.coded / res.total) * 100) : 0
          };
        })
        .catch((err) => {
          console.error('加载赋码统计失败', err);
          this.codingError = '加载统计失败：' + (err.message || '网络错误');
        });
    },
    // 打开批量赋码抽屉
    openBatchCodingDrawer() {
      this.batchCodingVisible = true;
      this.loadCodingStats();
    },
    // 单个快速赋码
    singleCoding(record) {
      this.$confirm({
        title: '确认赋码',
        content: `确定为商品"${record.name}"创建追溯产品记录？`,
        onOk: () => {
          this.codingLoading = true;
          goodsBatchCoding({ goods_ids: [record.id] })
            .then((res) => {
              this.$message.success(res.message || '赋码成功');
              this.list(); // 刷新列表
              this.loadCodingStats(); // 刷新统计
            })
            .catch((err) => {
              this.$message.error('赋码失败：' + (err.message || '网络错误'));
            })
            .finally(() => {
              this.codingLoading = false;
            });
        },
      });
    },
    // 批量赋码
    batchCoding() {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先选择要赋码的商品');
        return;
      }

      this.$confirm({
        title: '确认批量赋码',
        content: `确定为选中的 ${this.selectedRowKeys.length} 个商品创建追溯产品记录？`,
        onOk: () => {
          this.codingLoading = true;
          goodsBatchCoding({ goods_ids: this.selectedRowKeys })
            .then((res) => {
              this.$message.success(res.message || '批量赋码成功');
              this.selectedRowKeys = []; // 清空选中
              this.list(); // 刷新列表
              this.loadCodingStats(); // 刷新统计
              this.batchCodingVisible = false; // 关闭抽屉
            })
            .catch((err) => {
              this.$message.error('批量赋码失败：' + (err.message || '网络错误'));
            })
            .finally(() => {
              this.codingLoading = false;
            });
        },
      });
    },
    // 行选中回调
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    // 控制哪些行可以被选中（只有产品类型且未建档的商品才能选中）
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.types !== 'product' || record.trace_status !== 'unarchived'
        }
      };
    },
    // 跳转到追溯信息管理页面
    goToTrace(record) {
      this.$router.push({
        path: '/from/from_result',
        query: { product_id: record.id }
      });
    },
  },
}
</script>
